import { useState, useEffect } from "react"
import { db } from "../firebase/config"
import { collection, getDocs } from "firebase/firestore"

const useFetchUsersForOversight = () => {
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetch = async () => {
      try {
        const snap = await getDocs(collection(db, "users"))
        const results = snap.docs
          .map((d) => ({ uid: d.id, ...d.data() }))
          .sort((a, b) => (a.name || a.email || "").localeCompare(b.name || b.email || ""))
        setUsers(results)
      } catch (err) {
        console.error("useFetchUsersForOversight error:", err)
        setError(err.message)
      } finally {
        setLoading(false)
      }
    }
    fetch()
  }, [])

  return { users, loading, error }
}

export default useFetchUsersForOversight
